export const ALLOWED_FILE_EXTENSIONS = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.zip";

export const MAX_FILE_SIZE_MB = 20;

export const PAGE_SIZE = 24;

export const SEARCH_DEBOUNCE_MS = 300;

export const CONTENT_TYPE_LABELS: Record<string, string> = {
  "application/pdf": "PDF",
  "application/msword": "Word",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
  "application/vnd.ms-excel": "Excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "application/zip": "ZIP",
};

export { humanFileSize } from "@/shared/utils/fileHelpers";
